export const fontSize = {
  small: '12px',
  medium: '14px',
  large: '18px',
  larger: '21px',
  xlarger: '25px',
  huge: '29px',
  giant: '32px',
};

export const borderRadius = {
  normal: '15px',
  small: '4px',
};

export const fontWeight = {
  veryLight: 100,
  light: 300,
  normal: 500,
};

export const border = {};

export const lineHeight = {
  normal: 1.54,
  big: 2,
  medium: 1.29,
  huge: 2.33,
  filtersBar: '22px',
};

export const colors = {
  greyMid: '#919db4',
  greySecondary: '#586784',
  greyLight: '#cdd3e0',
  greyDark: '#3f435c',
  greyInputBorder: '#a2adc4',
  greyNotes: '#707070',

  blackSecondary: '#202329',
  blueDark: '#233b69',
  blueLight: '#02aff9',
  blueMed: '#0070ba',
  blue: '#1890ff',

  mainBackground: '#f0f2f5',
  imageBoxShadow: 'rgba(0, 105, 250, 0.30)',
  BlueBoxShadow: '#0069fa26',
  colorlessBoxShadow: 'rgba(0, 0, 0, 0.16)',
  borderLight: '#ebebeb',
  greenBright: '#08ac08',
  greenHover: '#43cb43',
  greenLight: '#D9FCD9',

  yellow: '#ffff88',
  orange: '#ff5700',
  beige: '#ffe6d9',
  red: '#c70000',
  pinkDark: '#ff3f71',
  disabledButton: '#acb6cb',
  disabledText: '#a9b2c8',
  disabledBorder: '#d9d9d9',
  lightWhite: '#D9E7FF',
  tableHeaderBackground: process.env.APP_NAME === 'TRIPLEMARS' ? '#f5f8fc' : '  #fcf5f5',
  tableHeaderFont: 'rgba(88, 103, 132, 0.8)',
  tableBorderColor: '#becbe4',

  whiteBackground: '#ffffff',
  whiteLightBackground: process.env.APP_NAME === 'TRIPLEMARS' ? '#fafbfe' : '#fefafa',
  whiteMediumBackground: process.env.APP_NAME === 'TRIPLEMARS' ? '#edf4fc' : '#ffe0e0',
  whiteDarkBackground: '#e4edf7',
  whiteFont: '#fefefe',
};

export const theme = {
  colors,
  fontSize,
  border,
  borderRadius,
  fontWeight,
  lineHeight,
};
